import type { TaskType } from "@common/types/task";
import type { TaskTemplateAssigneeRole } from "@common/types/taskTemplate";
import {
    TASK_TYPE_OPTION_GROUPS,
    resolveTaskTypeFromOption,
} from "../OrganizationCloseTemplates/closeTemplateTasksDrawer.constants";
import {
    matchesArchiveFilter,
    type ArchiveFilter,
} from "../templates/archiveFilter";
import type { OrganizationTaskTemplateRow } from "./organizationTaskTemplatesViewConfig";

const KICK_DEFAULT_ID_PREFIX = "kick-default:";

export const getKickDefaultTemplateRows = (): OrganizationTaskTemplateRow[] =>
    TASK_TYPE_OPTION_GROUPS.flatMap(({ options }) => options).map(
        ({ value, label }) => ({
            id: `${KICK_DEFAULT_ID_PREFIX}${value}`,
            name: label,
            closeStageId: null,
            assigneeRole: null,
            taskType: resolveTaskTypeFromOption(value),
            externalDeadline: null,
            deadlineAnchor: null,
            estimatedTime: null,
            kickDefaultOption: value,
        }),
    );

interface FilterKickDefaultTemplateRowsParams {
    search: string;
    archiveFilter: ArchiveFilter;
    types: readonly TaskType[] | undefined;
    groupIds: readonly string[] | undefined;
    assigneeRoles: readonly TaskTemplateAssigneeRole[] | undefined;
    createdByUserIds: readonly number[] | undefined;
}

export const filterKickDefaultTemplateRows = ({
    search,
    archiveFilter,
    types,
    groupIds,
    assigneeRoles,
    createdByUserIds,
}: FilterKickDefaultTemplateRowsParams): OrganizationTaskTemplateRow[] => {
    const hasGroupFilter = groupIds !== undefined && groupIds.length > 0;
    const hasRoleFilter =
        assigneeRoles !== undefined && assigneeRoles.length > 0;
    const hasCreatedByFilter =
        createdByUserIds !== undefined && createdByUserIds.length > 0;
    if (
        !matchesArchiveFilter({ isArchived: false, archiveFilter }) ||
        hasGroupFilter ||
        hasRoleFilter ||
        hasCreatedByFilter
    ) {
        return [];
    }
    const lowerSearch = search.toLowerCase();
    return getKickDefaultTemplateRows().filter(
        ({ name, taskType }) =>
            name.toLowerCase().includes(lowerSearch) &&
            (types === undefined ||
                types.length === 0 ||
                (taskType !== null && types.includes(taskType))),
    );
};
